// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"1998752eedb5b9a1a24d","777":"d68f5b6655a72dbf1178"}[chunkId] + ".chunk.js";
};